import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  bookmarkTitle: {
    color: "#465869",
    fontSize: 16,
    fontWeight: 700
  },
  timelineSubtitle: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 6,
    color: "#667085",
    marginTop: 3,
    "& > span": {
      marginLeft: 3
    }
  },
  uploadProgress: {
    height: 115,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    padding: "0 24px 24px",
    borderRadius: 8,
    marginTop: 12,
    marginBottom: 16,
    opacity: 0.7,
    background: "#f8fafc",
    cursor: "default",
    "&.withAnimation": {
      animation: `$bouncing 1s ease-in-out infinite`
    },
    "& > span": {
      fontSize: 14,
      fontWeight: 500,
      marginTop: 3
    }
  },
  "@keyframes bouncing": {
    "0%": {
      backgroundColor: "#f8fafc"
    },
    "50%": {
      backgroundColor: "#EDEFF1"
    },
    "100%": {
      backgroundColor: "#f8fafc"
    }
  }
}));

export default styles;
